import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitFirmwareModel } from '@apps-common/types/management/unit-firmware'

export const MANAGEMENT_QUERY_KEY_SEARCH_UNIT_FIRMWARE = (firmwareId?: string) => ['getUnitFirmware', firmwareId].filter(Boolean)

export const getUnitFirmware = async (firmwareId: string): Promise<IUnitFirmwareModel> =>
  axios.get(`/management/unitfirmware/getunitfirmware?firmwareId=${firmwareId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitFirmware

type Props = {
  config?: QueryConfig<QueryFnType>
  firmwareId: string
}

export const useManagementGetUnitFirmware = ({ config, firmwareId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_SEARCH_UNIT_FIRMWARE(firmwareId),
    queryFn: () => getUnitFirmware(firmwareId)
  })
